enum ActionTypes {
  MENTORSHIP_SET_PAGE = 'ADMIN_ACTIONS_MENTORSHIP_SET_PAGE',
  MENTORSHIP_SET_SEARCH = 'ADMIN_ACTIONS_MENTORSHIP_SET_SEARCH',
  MENTORSHIP_SET_TAKE = 'ADMIN_MENTEE_MENTORSHIP_SET_TAKE',

  FORMATION_SET_PAGE = 'ADMIN_MENTEE_FORMATION_SET_PAGE',
  FORMATION_SET_SEARCH = 'ADMIN_MENTEE_FORMATION_SET_SEARCH',
  FORMATION_SET_TAKE = 'ADMIN_MENTEE_FORMATION_SET_TAKE',
}

export default ActionTypes;
